import { WORKFORCE_CAPABILITY_ROLE_GRANTS } from '@/lib/workforce/phase1a-capabilities';

/** Preserve the former People home cohort, including HR officer reads. */
export const PEOPLE_SETTINGS_READ_ROLES = WORKFORCE_CAPABILITY_ROLE_GRANTS['workforce.people.view'];

/** Linked configuration tools retain their narrower historical cohort. */
export const PEOPLE_SETTINGS_TOOL_READ_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'HR_DIRECTOR',
  'HR_OFFICER',
] as const;
export const PEOPLE_SETTINGS_READ_ONLY_NOTE =
  'Only an administrator or HR director can change this';
export const PEOPLE_SETTINGS_SECTIONS = [
  { id: 'onboarding', label: 'Onboarding' },
  { id: 'documents', label: 'Documents' },
  { id: 'policies', label: 'Policies' },
  { id: 'learning', label: 'Learning' },
  { id: 'legal-checks', label: 'Legal checks' },
] as const;
export function isPeopleSettingsPath(pathname: string): boolean {
  pathname = pathname.split(/[?#]/, 1)[0] ?? pathname;
  return [
    '/settings/people',
    '/settings/onboarding',
    '/settings/onboarding-packs',
    '/settings/document-templates',
  ].some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export const PEOPLE_SETTINGS_SECTION_PATHS: Record<
  (typeof PEOPLE_SETTINGS_SECTIONS)[number]['id'],
  readonly string[]
> = {
  onboarding: [
    '/settings/onboarding',
    '/settings/onboarding/worker',
    '/settings/onboarding/worker/base',
    '/settings/onboarding/induction-policies',
    '/settings/onboarding-packs',
    '/settings/onboarding/readiness',
  ],
  documents: ['/settings/document-templates', '/settings/people/assignment-requirements'],
  policies: [],
  learning: [],
  'legal-checks': ['/settings/onboarding/screening', '/settings/onboarding/consents'],
};
